export const yymmToYearMonth = (yymm: string) => {
  const yy = Number(yymm.slice(0, 2))
  const mm = Number(yymm.slice(2, 4))
  return {year: 2000 + yy, month: mm}
}

export const currentYyMm = () => {
  const now = new Date()
  const yy = String(now.getFullYear()).slice(-2)
  const mm = String(now.getMonth() + 1).padStart(2, '0')
  return `${yy}${mm}`
}

export const monthLabelFromYyMm = (yymm?: string | null) => {
  if (!yymm) return ''
  const {year, month} = yymmToYearMonth(yymm)
  const d = new Date(year, month - 1, 1)
  return d.toLocaleString(undefined, {month: 'long', year: 'numeric'})
}

export const getCalendarMatrix = (yymm: string) => {
  const {year, month} = yymmToYearMonth(yymm)
  const firstDay = new Date(year, month - 1, 1)
  const startDow = firstDay.getDay()
  const daysInMonth = new Date(year, month, 0).getDate()

  const prevMonthDays = new Date(year, month - 1, 0).getDate()

  const cells: {date: Date; outside: boolean}[] = []
  for (let i = startDow - 1; i >= 0; i -= 1) {
    cells.push({
      date: new Date(year, month - 2, prevMonthDays - i),
      outside: true,
    })
  }
  for (let d = 1; d <= daysInMonth; d += 1) {
    cells.push({date: new Date(year, month - 1, d), outside: false})
  }
  while (cells.length % 7 !== 0) {
    const last = cells[cells.length - 1].date
    cells.push({
      date: new Date(last.getFullYear(), last.getMonth(), last.getDate() + 1),
      outside: true,
    })
  }
  return cells
}

export const buildSlotsByDate = (
  days: {date: string; slots: string[]}[],
): Map<string, string[]> => {
  const map = new Map<string, string[]>()
  days.forEach((d) => map.set(d.date, d.slots))
  return map
}
